import { dashedBorders } from '@utils/styles'
import { twMerge } from '@lib/tailwind-merge'

interface SideCellProps {
  className?: string
  children?: React.ReactNode
  testId?: string
  rowIndex: number
  highlight?: boolean
  showBorder?: boolean
}

export function SideCell({
  className,
  children,
  testId,
  rowIndex,
  highlight,
  showBorder,
}: SideCellProps) {
  const style = {
    gridRowStart: rowIndex,
  }

  return (
    <div
      className={twMerge(
        'flex flex-row items-center',
        dashedBorders,
        highlight && 'bg-neutral-100',
        showBorder && 'first:border-t border-t',
        className,
      )}
      data-rowindex={rowIndex}
      data-testid={testId}
      style={style}
    >
      {children}
    </div>
  )
}
